import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import "./Odberatel.scss";

// prop types
import odberatelPropTypes from "../../propTypes/odberatelPropTypes";

// actions
import * as appHeaderActions from "../../actions/appHeaderActions";

// components
import ErrorMsg from "../ErrorMsg";
import LoadingPanel from "../../coraWebComponents/LoadingPanel";

const SCHEMA_FO = [
  { field: "NAZOV", title: "Meno a priezvisko/Názov" },
  { field: "ADRESA_SIDLO", title: "Adresa/sídlo" },
  { field: "EMAIL1", title: "E-mail" },
  { field: "TELEFON", title: "Telefón" },
];

const SCHEMA_PO = [
  { field: "NAZOV", title: "Meno a priezvisko/Názov" },
  { field: "PRAVNAFORMA", title: "Právna forma" },
  { field: "ICO_DIC", title: "IČO/DIČ" },
  { field: "ADRESA_SIDLO", title: "Adresa/sídlo" },
  { field: "EMAIL1", title: "E-mail" },
  { field: "TELEFON", title: "Telefón" },
];

class Odberatel extends React.Component {
  // METHODS
  renderDataForWeb = () => {
    const schema = this.props.odberatel.I_O_TYP === 1 ? SCHEMA_FO : SCHEMA_PO;

    return schema.map((obj, key) => {
      const { field, title } = obj;

      return (
        <React.Fragment key={key}>
          <div className="col-3 pl-3 title" key={title}>
            <p>{title}: </p>
          </div>
          <div className="col-9 pl-3" key={field}>
            <p>{this.props.odberatel[field]}</p>
          </div>
        </React.Fragment>
      );
    });
  };
  renderDataForMobile = () => {
    const schema = this.props.odberatel.I_O_TYP === 1 ? SCHEMA_FO : SCHEMA_PO;

    return schema.map((obj, key) => {
      const { field, title } = obj;

      return (
        <React.Fragment key={key}>
          <div className="col-5 p-0 title" key={title}>
            <p>{title}: </p>
          </div>
          <div className="col-7 p-0" key={field}>
            <p>{this.props.odberatel[field]}</p>
          </div>
        </React.Fragment>
      );
    });
  };

  // SYSTEM METHODS
  componentDidMount() {
    const { showAppHeader, changeHeaderTitle } = this.props;

    showAppHeader(false);
    changeHeaderTitle("Odberateľ");
  }
  render() {
    const { isOdberatelPicked, isLoading } = this.props;

    return (
      <div className="row m-0 component">
        <div className="col p-0">
          <div className="webOdberatel">
            <div className="row m-0">
              {isOdberatelPicked && this.renderDataForWeb()}
            </div>
          </div>
          <div className="mobileOdberatel">
            <div className="row m-0">
              {isOdberatelPicked && this.renderDataForMobile()}
            </div>
          </div>

          {!isOdberatelPicked && <ErrorMsg text="Vyberte odberateľa" />}
          <LoadingPanel isLoading={isLoading} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.odberatel.isLoading,
    isOdberatelPicked: state.odberatel.isPicked,
    odberatel: state.odberatel.data,
  };
};

const mapDispatchToProps = (dispatch) => ({
  changeHeaderTitle: (title) =>
    dispatch(appHeaderActions.changeHeaderTitle(title)),
  showAppHeader: (show) => dispatch(appHeaderActions.showAppHeader(show)),
});

Odberatel.propTypes = {
  changeHeaderTitle: PropTypes.func,
  isLoading: PropTypes.bool,
  isOdberatelPicked: PropTypes.bool,
  odberatel: odberatelPropTypes.odberatel,
  showAppHeader: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Odberatel);
